module.exports = __webpack_public_path__ + "static/media/google-play-badge.47d88f8b.png";